import { useRef, useState } from "react";

const NoteBookSlider = (props) => {
    const concRef = useRef(null);
    const divRef = useRef(null);
    const [slideVisible, setSlideVisible] = useState(false);
    const [scrollX, setScrollX] = useState(0);

    const handleSlide = (dir) => {
        const currentConc = concRef.current;
        const currentDiv = divRef.current;
        //visible length is div 
        const divVisibleWidth = currentDiv.offsetWidth;
        const visibleWidth = currentConc.offsetWidth;
        const maxScrollWidth = currentConc.scrollWidth;
        let newScroll = dir === 'right' ? visibleWidth + scrollX :  scrollX - visibleWidth;
        newScroll = Math.max(0, Math.min(newScroll, maxScrollWidth));
        setSlideVisible(newScroll !== 0 ? true : false)
        currentConc.scrollTo({
            left: newScroll,
            behavior: "smooth",
        })
        setScrollX(newScroll)
    }
    const handleSelectedPrompt = (prompt) => {
        let query = prompt.map(x => {
            let finalAns = "";
            if (x.readingLevel) {
                finalAns += `Answer this question about the study as if you were a medical writer explaining to an ${x.readingLevel}th grader`
            }
            finalAns += ` "${x.prompt}" Use simple language`
            if (x.word_limit) {
                finalAns += ` and less than ${x.word_limit} words`
            }
            return finalAns;
        })
        props.handleAddTemplatePrompts(query[0])
    }

    /*return (
        <div className="slider-container" style={{ height: 'auto' }}>
            <div
                className={`slider ${slide ? "slide-left" : ""}`} style={{ height: 'auto' }}
            >
                {(props.prompt.length > 0) && props.prompt.map((x, id) => <div className="panel panel-1 notebook-prompts">
                    <span className="noteBook-prop-text">{x.prompt}</span>
                </div>)}
            </div>
                <div className="arrow notebook-view-more" onClick={() => setSlide(!slide)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M2.6665 8H13.3328M13.3328 8L9.33294 4M13.3328 8L9.33294 12" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
        </div>
    );*/
    return (
        <div className="mx-12" style={{ width: "100%", position: 'relative', display: 'flex', }}>
            {(slideVisible) && <div className="notebook-view-more" title="Slide Left" style={{ right: 'auto', left: '-0.5rem' }} onClick={() => handleSlide('left')}>
                <svg style={{ transform: "rotate(180deg)" }} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M2.6665 8H13.3328M13.3328 8L9.33294 4M13.3328 8L9.33294 12" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>}
            <div ref={concRef} className="notebook-prompt-section" style={{ overflow: 'hidden', width: '90%', marginLeft: '30px' }}>
                {(props.prompt.length > 0) ? props.prompt.map(x => <div ref={divRef} className="notebook-prompts" onClick={() => handleSelectedPrompt([x])}>
                    <span className="noteBook-prop-text">{x.prompt}</span>
                </div>) : <div style={{ height: '60px', marginLeft: "12px" }}><span className="noteBook-prop-text">{'*No prompt selected'}</span></div>}
            </div>
            <div title='Slide Right' className="notebook-view-more" onClick={() => handleSlide('right')}>
                <svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M2.6665 8H13.3328M13.3328 8L9.33294 4M13.3328 8L9.33294 12" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>
        </div>
    )

}
export default NoteBookSlider;
